import { CreateReferencesState } from './createReferencesTypes';
import {
  ObservableState,
  persistentReducedStream,
  reducer,
  toPersistentStream,
} from '@ardoq/rxbeach';
import {
  linkUpdate,
  setLinkSources,
  setLinkTarget,
} from '@ardoq/component-hierarchies';
import { createReferencesOperations } from './createReferencesOperations';
import { defaultCreateReferencesState } from './defaultCreateReferencesState';
import { createReferenceSourceChanged } from './createReferencesActions';
import { map } from 'rxjs';

export const createReferences$: ObservableState<CreateReferencesState> =
  persistentReducedStream<CreateReferencesState>(
    'createReferences$',
    defaultCreateReferencesState,
    [
      reducer(setLinkSources, createReferencesOperations.setLinkSources),
      reducer(linkUpdate, createReferencesOperations.linkUpdate),
      reducer(setLinkTarget, createReferencesOperations.reset),
      reducer(
        createReferenceSourceChanged,
        createReferencesOperations.createReferenceSourceChanged
      ),
    ]
  );

export const isLinking$ = toPersistentStream(
  'isLinking$',
  createReferences$.pipe(map(({ isLinking }) => isLinking)),
  false
);
